import contact from './module/contact';
import HOME from './module/home';
import INIT from './module/init';
import UAV3D from './module/uav3d';
import SOLUTION from './module/solution';
import EQUIPMENT from './module/equipment';
import ABOUTUS from './module/aboutus';
import TECHNICAL from './module/technical';

new INIT();
switch( location.pathname.replace(/^(\/[^/]+)\/([^/]+\/)?(.*)?$/,'$1/$2') ){
  case '/': HOME(); break
  case '/aboutus/': ABOUTUS(); break
  case '/contact/': contact(); break
  case '/technical/': TECHNICAL(); break
  case '/technical/uav3d/': UAV3D(); break
  case '/technical/equipment/': EQUIPMENT(); break
  case '/solution/': SOLUTION(); break
}